import {map, size} from 'lodash-es';
import {MachineOverviewList} from './machine-overview-list';

export class MachineGroupOverviewList {
  private _id: number;
  private _name: string;
  private _groups: MachineGroupOverviewList[];
  private _machines: MachineOverviewList[];
  private _imageId: number;
  private _imageName: string;
  private _root: boolean;

  public constructor(id: number, name: string, imageId: number, imageName: string, root: boolean, groups: MachineGroupOverviewList[], machines: MachineOverviewList[]) {
    this._id = id;
    this._name = name;
    this._imageId = imageId;
    this._imageName = imageName;
    this._root = root;
    this._groups = groups;
    this._machines = machines;
  }

  public get id(): number {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get imageId(): number {
    return this._imageId;
  }

  public get imageName(): string {
    return this._imageName;
  }

  public get root(): boolean {
    return this._root;
  }

  public get groups(): MachineGroupOverviewList[] {
    return this._groups;
  }

  public set groups(groups: MachineGroupOverviewList[]) {
    this._groups = groups;
  }

  public get machines(): MachineOverviewList[] {
    return this._machines;
  }

  public set machines(machines: MachineOverviewList[]) {
    this._machines = machines;
  }

  public static fromJSON(overviewMachinesJSON: any): MachineGroupOverviewList {
    const groups: MachineGroupOverviewList[] =
      size(overviewMachinesJSON.groups) > 0
        ? map(overviewMachinesJSON.groups, (possibleMachineGroup: any) => {
            return MachineGroupOverviewList.fromJSON(possibleMachineGroup);
          })
        : [];

    const machines: MachineOverviewList[] =
      size(overviewMachinesJSON.machines) > 0
        ? map(overviewMachinesJSON.machines, (possibleMachine: any) => {
            return MachineOverviewList.fromJSON(possibleMachine);
          })
        : [];

    return new MachineGroupOverviewList(overviewMachinesJSON.id, overviewMachinesJSON.name, overviewMachinesJSON.imageId, overviewMachinesJSON.imageName, overviewMachinesJSON.root, groups, machines);
  }

  public static createEmptyGroup(): MachineGroupOverviewList {
    return new MachineGroupOverviewList(null, null, null, null, false, [], []);
  }
}
